import { render, staticRenderFns } from "./KifuFormPublic.vue?vue&type=template&id=81ef84c4&scoped=true&"
import script from "./KifuFormPublic.vue?vue&type=script&lang=js&"
export * from "./KifuFormPublic.vue?vue&type=script&lang=js&"
import style0 from "./KifuFormPublic.vue?vue&type=style&index=0&id=81ef84c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ef84c4",
  null
  
)

export default component.exports